// src/pages/Purchase/PurchaseDashboard.jsx
import React from "react";
import { Card, Row, Col, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { ShoppingCartOutlined } from "@ant-design/icons";
import "./purchaseDashboard.css";
import { accessChecker } from "../../lib/functions";

const { Title } = Typography;

const PurchaseDashboard = () => {
  const navigate = useNavigate();

  const links = [
    {
      key: "purchase_entry",
      title: "Purchase Entry",
      value: "purchase_entry",
      path: "/purchase?tab=entry",
    },
    { 
      key: "supplier_entry",
      title: "Supplier Entry",
      value: "supplier_entry",
      path: "/purchase?tab=sentry",
    },
    {
      key: "tatmeen_entry",
      title: "SSCC Aggregation",
      value: "tatmeen_entry",
      path: "/purchase?tab=sscc",
    },
    {
      key: "purchase_entry",
      title: "Parsing Logic",
      value: "purchase_entry",
      path: "/purchase?tab=cutting-logic",
    },
    {
      key: "purchase_record",
      title: "Purchase Record",
      value: "purchase_record",
      path: "/purchase?tab=record",
    },
    {
      key: "purchase_voucher",
      title: "Purchase Voucher",
      value: "purchase_voucher",
      path: "/purchase?tab=voucher",
    },
    {
      key: "purchase_return",
      title: "Purchase Return Entry",
      value: "purchase_return",
      path: "/purchase-return?tab=entry",
    },
    {
      key: "purchase_return_record",
      title: "Purchase Return Record",
      value: "purchase_return_record",
      path: "/purchase-return?tab=record",
    },
    {
      key: "purchase_return_voucher",
      title: "Purchase Return Voucher",
      value: "purchase_return_voucher",
      path: "/purchase-return?tab=voucher",
    },
  ];

  const filteredMenuData = links.filter((menuItem) =>
    accessChecker(menuItem.value)
  );
  return (
    <div className="dashboard-container">
      <Title level={3}>Purchase Dashboard</Title>
      <Row gutter={[16, 16]}>
        {filteredMenuData
          ?.sort((a, b) => a.title.localeCompare(b.title))
          .map((item, i) => (
            <Col xs={24} sm={12} md={8} lg={6} key={i}>
              <Card
                hoverable
                onClick={() => navigate(item.path)}
                className="dashboard-card"
              >
                <ShoppingCartOutlined
                  style={{ fontSize: 28, marginBottom: 12 }}
                />
                <p>{item.title}</p>
              </Card>
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default PurchaseDashboard;
